const TStrings = {
    EVENT_CLICK_BUTTON_TITLE: 'View',
};

export default TStrings;
